import axios from "axios";
import { decodeAuthToken } from "@/lib/decode-token";
import { axiosInstance } from "@/lib/axiosInstance";
import config from "@/lib/config";
import { string } from "zod";

type LoginPayload = {
  email: string;
  password: string;
};

type RegisterPayload = {
  email: string;
  password: string;
  companyName: string;
};

// type LoginResponse = {
//   token: string;
// };

export async function handleLogin(
  email: string,
  password: string
): Promise<string> {
  const data: LoginPayload = {
    email,
    password,
  };
  try {
    const response = await axiosInstance.post<any>(
      `${config.apiUrl}/auth/login`,
      data
    );
    const { token } = response.data;
    localStorage.setItem("user", JSON.stringify(response.data));
    localStorage.setItem("accessToken", token);
    decodeAuthToken(token);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Axios error:", error.response?.data);
    } else {
      console.error("Unknown error:", error);
    }
    throw error;
  }
}

// registration logic

export async function signupUser(
email: string, password: string, companyName: string): Promise<any> {

  const userData: RegisterPayload = {
    email,
    password,
    companyName,
  };
  const response = await axiosInstance.post(`${config.apiUrl}/auth/register`, {
    companyName: userData.companyName,
    email: userData.email.toLowerCase(),
    password: userData.password,
  });
  return response;
}
